import { MailOutlineRounded, OpenInNew } from '@mui/icons-material';
import React from 'react';
import Markdown, { type Components } from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import rehypeRaw from 'rehype-raw';
import remarkMath from 'remark-math';

import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';

interface Props {
  children?: string;
  dictKey?: string;
  components?: Components;
}

export default function CMarkdownText(props: Props) {
  return (
    <Markdown
      rehypePlugins={[rehypeRaw, rehypeKatex]}
      remarkPlugins={[remarkMath]}
      components={{
        p: ({ children }: { children?: React.ReactNode }) => <>{children}</>,
        a: ({ node, children, href, target, ...rest }) => {
          const isMailto = href?.startsWith('mailto:');

          return (
            <a href={href} target={target} {...rest}>
              {isMailto && (
                <>
                  <MailOutlineRounded style={{ fontSize: '90%' }} />
                  &nbsp;
                </>
              )}
              <span className={'underline'}>{children}</span>
              {target === '_blank' && (
                <>
                  &#8239;
                  <OpenInNew style={{ fontSize: '90%' }} />
                </>
              )}
            </a>
          );
        },
        ...props.components
      }}
    >
      {props.dictKey ? CLocalizedTextStringStatic(props.dictKey) : props.children}
    </Markdown>
  );
}
